import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEn001: CultureInfo = {
  name: 'en-001',
  displayName: 'English (World)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-001',
  parent: CultureInfoEn
};
